module.exports = __webpack_public_path__ + "img/horizontal_4_1_3016.e2b34683.png";